import angular from 'angular';
import moment from 'moment';
import { TipoBeneficios } from '../../beneficios.enum';
import { TipoSolicitacaoEnum } from '../../../../../../shared/enums/TipoSolicitacaoEnum';
import { MeurhBeneficiosService } from '../../beneficios.service';
import { TiposDocumentosRequeridosService } from '../../../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import { IBeneficioTrabalhadorDetalhado } from '../../model/beneficios.model';
import { IAnexo } from '../../../../../Meurh/Anexos/models/anexo.model';
import { ISuspensaoBeneficioGet } from '../../model/suspensao.model';
import { IReativacaoBeneficioSave } from '../../model/reativacao.model';

export class ReativacaoModalController {
    static $inject = [
        '$uibModalInstance',
        '$rootScope',
        '$scope',
        '$state',
        'entity',
        'MeurhBeneficiosService',
        'TiposDocumentosRequeridosService',
        'NewToaster'
    ];

    public form: angular.IFormController;
    public entityForm: {
        datareativacao: Date | string,
        observacao: string
    };
    public tipoBeneficios = TipoBeneficios;
    public limitDate: string;
    public limitEndDate: string;
    public busy = false;

    public formAnexo: angular.IFormController;
    public entityAnexo: IAnexo = {
        casodeuso: 'REATIVACAOBENEFICIO'
    };
    public tiposdocumentosrequeridos: any[];
    public busyTipoDocumentos = false;

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public $rootScope: angular.IRootScopeService & { session: any },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public entity: IBeneficioTrabalhadorDetalhado,
        public MeurhBeneficiosService: MeurhBeneficiosService,
        public TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
        public NewToaster: { pop: Function }
    ) {
        this.limitDate = this.setLimitDate(entity.ultima_suspensao?.datainicio);
        this.limitEndDate = this.setLimitEndDate(entity.ultima_suspensao?.datafim);

        this.carregaTiposDocumentosRequeridos();

        $scope.$on('meurh_solicitacoesreativacaobeneficios_create_loaded', (event, args: ISuspensaoBeneficioGet) => {
            if (this.tiposdocumentosrequeridos.length <= 0) {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'Reativação de benefício foi criada',
                    body: 'A reativação de benefício foi criada com sucesso.'
                });
                this.$state.go('meurh_beneficios_show_reativacao', {
                    'solicitacao': args.solicitacao
                });
                this.$uibModalInstance.close();
                this.busy = false;
            } else {
                this.entityAnexo['solicitacao'] = args.solicitacao;
                this.$rootScope.$broadcast('meurh_todas_solicitacoes_submitted', {});

                this.$scope.$on('meurh_todas_solicitacoes_documentos_complete', () => {
                    this.$scope.$apply(); // para atualizar os valores dos validateResult vindos do componente anexo
                    if (this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => tipodocumentorequerido.validateResult)) {
                        this.NewToaster.pop({
                            type: 'success',
                            title: 'Reativação de benefício foi criada',
                            body: 'A reativação de benefício foi criada com sucesso.'
                        });
                        this.$state.go('meurh_beneficios_show_reativacao', {
                            'solicitacao': args.solicitacao
                        });
                        this.$uibModalInstance.close();
                        this.busy = false;
                    }
                });
            }
        });

        $scope.$on('meurh_tiposdocumentosrequeridos_list_finished', () => {
            this.busyTipoDocumentos = false;
            this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
                tipodocumentorequerido.validateResult = false;
                tipodocumentorequerido.fileSelecionado = false;
                return tipodocumentorequerido;
            });
        });

        $scope.$on('meurh_solicitacoesreativacaobeneficios_create_error', (event, args: any) => {
            this.busy = false;
			let error = `Ocorreu um erro ao criar a reativação de benefício.`;
            if (args.data?.message) {
                error = args.data.message;
            }
            this.NewToaster.pop({
                type: 'error',
                title: error
            });
		});
    }

    submit() {
        this.form.$submitted = true;

        if (this.form.$invalid) {
            return;
        }

        const docsValid = this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => {
            return (
                tipodocumentorequerido.fileSelecionado === tipodocumentorequerido.obrigatorio ||
                tipodocumentorequerido.fileSelecionado
            );
        });
        if (!docsValid) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Há documento(s) obrigatório(s) não informado(s)'
            });
            return;
        }

        this.busy = true;
        this.MeurhBeneficiosService.saveReativacaoBeneficio(this.setRequestBody());
    }

    close() {
        this.$uibModalInstance.dismiss('fechar');
    }

    setLimitDate(value?: Date | string) {
        if (!value || value === '') {
            return '';
        }
        return moment(value).add(1, 'day').format('YYYY-MM-DD');
    }

    setLimitEndDate(value?: Date | string) {
        if (!value || value === '') {
            return '';
        }
        return moment(value).subtract(1, 'day').format('YYYY-MM-DD');
    }

    setRequestBody(): IReativacaoBeneficioSave {
        return {
            trabalhador: this.entity.trabalhador.trabalhador,
            situacao: 0,
            estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento,
            beneficio: this.entity.beneficio.beneficio,
            datareativacao: this.entityForm.datareativacao,
            observacao: this.entityForm.observacao,
            beneficiotrabalhador: this.entity.beneficiotrabalhador
        };
    }

    carregaTiposDocumentosRequeridos() {
        this.busyTipoDocumentos = true;
        this.resetTiposDocumentosRequeridosService();
        this.TiposDocumentosRequeridosService.constructors = {
            tiposolicitacao: TipoSolicitacaoEnum.REATIVACAO_BENEFICIO
        };
        this.tiposdocumentosrequeridos = this.TiposDocumentosRequeridosService.load();
    }

    resetTiposDocumentosRequeridosService() {
        this.tiposdocumentosrequeridos = [];
        this.TiposDocumentosRequeridosService.entities = [];
        this.TiposDocumentosRequeridosService.loadParams = {
            to_load: 3,
            busy: false,
            finished: false
        };
        this.TiposDocumentosRequeridosService.after = {};
    }
}
